<template>
  <div class="containerWrapper mb-4">
    <DataTable :value="processOrderList(FINISHED_ORDERS_BY_TYPE('feralco', true))" :autoLayout="true" data-key="order.id" :selection.sync="selectedFinishedOrders" :filters="filters">
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column field="date" header="Lossningsdatum" :sortable="true" />
      <Column header="OrderId" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.SalesId ? slotProps.data.order.data.SalesId : slotProps.data.order.data.fraktsedelNr}}
        </template>
      </Column>
      <Column header="Destination" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.DeliveryPlaceCity ? slotProps.data.order.data.DeliveryPlaceCity : slotProps.data.order.data.deliveryPlaces}}
        </template>
      </Column>
      <Column header="Produkt" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.ItemId ? slotProps.data.order.data.ItemId : slotProps.data.order.data.productId}}
        </template>
      </Column>
      <Column field="order.data.GroupLoading" header="Samlast" :sortable="true" />
      <Column header="Kvantitet" bodyStyle="text-align: right" :sortable="true">
        <template #body="slotProps">
          {{slotProps.data.order.data.Quantity ?
            parseFloat(slotProps.data.order.data.Quantity.replace(',', '.')).toFixed(2) :
            parseFloat(slotProps.data.order.data.quantity.replace(',', '.')).toFixed(2)}}
        </template>
      </Column>
      <Column headerStyle="width: 8em" bodyStyle="text-align: center">
        <template #header>
          <Button type="button" :icon="editAllowed ? 'pi pi-unlock' : 'pi pi-lock'" @click="editAllowed = !editAllowed"></Button>
        </template>
        <template #body="slotProps">
          <Button icon="pi pi-undo" :disabled="!editAllowed" @click="resetOrder(slotProps.data.order.id)" />
          <Button icon="pi pi-ban" :disabled="!editAllowed" @click="archiveOrder(slotProps.data.order.id)" />
        </template>
      </Column>
      <template #header>
        <div class="p-d-flex">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
            </span>
            <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
            <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="newInvoice = true" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="p-d-flex">
          <div class="p-inputgroup">
            <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length === 0" @click="newInvoice = true" />
          </div>
        </div>
      </template>
      <template #empty>
        Inga ordrar redo för fakturering ännu
      </template>
    </DataTable>

    <Dialog header="Ange namn för ny faktura" :visible.sync="newInvoice">
      <InputText v-model="newInvoiceName" placeholder="Fakturanamn" size="50" />
      <template #footer>
        <Button label="Skapa faktura" icon="pi pi-check" :disabled="newInvoiceName.length === 0" @click="addToNewInvoice(newInvoiceName, selectedFinishedOrders)"/>
        <Button label="Avbryt" icon="pi pi-times" class="p-button-secondary" @click="newInvoice = false" />
      </template>
    </Dialog>

    <template v-for="activeInvoice in INVOICES_NEW_BY_TYPE('feralco').sort((e1, e2) => (-1))" data-key="activeInvoice.id">
      <DataTable :value="processInvoiceList(activeInvoice.invoiceDatas)" :autoLayout="true" data-key="order.id" :key="activeInvoice.id" :selection.sync="selectedOrdersToRemove[activeInvoice.id]">
        <template #header>
          <div class="p-d-flex">
            <div class="p-inputgroup">
              <Button label="Lägg till" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="appendToInvoice(activeInvoice.id, selectedFinishedOrders)" />
              <Button label="Ta bort" icon="pi pi-minus" class="p-button-danger" :disabled="selectedOrdersToRemove[activeInvoice.id] === undefined || selectedOrdersToRemove[activeInvoice.id].length == 0" @click="removeFromInvoice(activeInvoice.id, selectedOrdersToRemove[activeInvoice.id])" />
              <span class="p-inputgroup-addon" style="color: black">
                {{activeInvoice.name}}
              </span>
            </div>
          </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3em" />
        <Column field="date" header="Lossningsdatum" :sortable="true" />
        <Column header="OrderId" :sortable="true">
          <template #body="slotProps">
            {{slotProps.data.order.Order.data.SalesId ? slotProps.data.order.Order.data.SalesId : slotProps.data.order.Order.data.fraktsedelNr}}
          </template>
        </Column>
        <Column header="Destination" :sortable="true">
          <template #body="slotProps">
            {{slotProps.data.order.Order.data.DeliveryPlaceCity ? slotProps.data.order.Order.data.DeliveryPlaceCity : slotProps.data.order.Order.data.deliveryPlaces}}
          </template>
        </Column>
        <Column header="Produkt" :sortable="true">
          <template #body="slotProps">
           {{slotProps.data.order.Order.data.ItemId ? slotProps.data.order.Order.data.ItemId : slotProps.data.order.Order.data.productId}}
          </template>
        </Column>
        <Column field="order.Order.data.GroupLoading" header="Samlast" :sortable="true" />
        <Column header="Kvantitet" bodyStyle="text-align: right" :sortable="true">
          <template #body="slotProps">
            {{slotProps.data.order.Order.data.Quantity ?
              parseFloat(slotProps.data.order.Order.data.Quantity.replace(',', '.')).toFixed(2) :
              parseFloat(slotProps.data.order.Order.data.quantity.replace(',', '.')).toFixed(2)}}
          </template>
        </Column>
        <template #footer>
          <div class="p-d-flex p-jc-between">
            <div class="p-inputgroup">
              <Button label="Fakturera" icon="pi pi-check" class="p-button-success" :disabled="activeInvoice.invoiceDatas.length === 0" @click="$router.push({ name: 'InvoiceFeralcoCreate', params: { id: activeInvoice.id } })" />
            </div>
            <div class="p-inputgroup">
              <Button label="Ta Bort Faktura" icon="pi pi-minus" class="p-button-danger" :disabled="activeInvoice.invoiceDatas.length > 0" @click="deleteInvoice(activeInvoice.id)" />
              <Button label="Arkivera" icon="pi pi-minus" class="p-button-danger" @click="archiveInvoice(activeInvoice.id)" />
            </div>
          </div>
        </template>
        <template #empty>
          Inga ordrar tillagda på {{activeInvoice.name}}
        </template>
      </DataTable>
    </template>

  </div>
</template>
<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import SplitButton from 'primevue/splitbutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import moment from 'moment'

import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceFeralcoList',
  components: {
    DataTable,
    Column,
    SplitButton,
    Button,
    InputText,
    Dialog
  },
  data () {
    return {
      editAllowed: false,
      newInvoice: false,
      newInvoiceName: '',
      createInvoice: -1,
      filters: {},
      selectedOrdersToRemove: {},
      selectedFinishedOrders: [],
      items: [
        {
          label: 'Ladda nya',
          icon: 'pi pi-refresh',
          command: () => {
            this.$store.dispatch('GET_FINISHED_ORDERS')
          }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('GET_FINISHED_ORDERS')
    this.$store.dispatch('GET_ACTIVE_INVOICES')
    this.$store.dispatch('GET_VISMA_ARTICLES')
  },
  computed: {
    ...mapGetters(['FINISHED_ORDERS', 'FINISHED_ORDERS_BY_TYPE', 'INVOICES', 'INVOICES_NEW_BY_TYPE'])
  },
  methods: {
    processOrderList (orders) {
      return orders.map((order) => {
        return { date: this.getDeliveryDate(order.data.orderRows), order: order }
      })
    },
    deProcessOrderList (orders) {
      return orders.map((order) => {
        return {...order.order}
      })
    },
    processInvoiceList (orders) {
      return orders.map((order) => {
        return { date: this.getDeliveryDate(order.Order.data.orderRows), order: order }
      })
    },
    async refresh () {
      await this.$store.dispatch('GET_FINISHED_ORDERS')
      await this.$store.dispatch('GET_ACTIVE_INVOICES')
    },
    async refreshAndClear () {
      await this.refresh()
      this.selectedFinishedOrders = []
    },
    async addToNewInvoice (name, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_NEW_INVOICE', { invoiceType: 'feralco', invoiceName: name, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
      this.newInvoice = false
      this.newInvoiceName = ''
    },
    async appendToInvoice (invoiceId, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
    },
    async removeFromInvoice (invoiceId, orders) {
      await this.$store.dispatch('REMOVE_ORDERS_FROM_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refresh()
      this.selectedOrdersToRemove[invoiceId] = []
    },
    async deleteInvoice (invoiceId) {
      await this.$store.dispatch('DELETE_INVOICE', invoiceId)
      await this.refresh()
    },
    archiveInvoice (invoiceId) {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$store.dispatch('ARCHIVE_INVOICE', invoiceId)
          this.refresh()
        })
        .catch(function (e) {
          console.log('Clicked on cancel')
        })
    },
    async archiveOrder (orderId) {
      await this.$store.dispatch('CHANGE_ORDER_STATE', { id: orderId, state: 'arkiverad' })
    },
    async resetOrder (orderId) {
      await this.$store.dispatch('CHANGE_ORDER_STATE', { id: orderId, state: 'avslutad' })
    },
    getDeliveryDate (orderRows) {
      const startDate = moment('2019-01-01')
      const date = orderRows.reduce((acc, curr) => {
        return acc.isSameOrBefore(moment(curr.endTime)) ? moment(curr.endTime) : acc
      }, startDate)
      return date.isSame(startDate) ? 'Felaktigt Datum' : date.format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceFeralcoList.vue